// Mapas de status para <ui-badge>: cada modulo registra o seu conjunto
// (status -> [rotulo, tom]) e usa <ui-badge set="modulo" :status="...">.
// Tons: success, warning, danger, info, primary, purple, teal, neutral.
const sets = {
  default: {
    active: ["Ativo", "success"],
    inactive: ["Inativo", "neutral"],
    pending: ["Pendente", "warning"],
    approved: ["Aprovado", "success"],
    rejected: ["Rejeitado", "danger"],
    cancelled: ["Cancelado", "neutral"],
  },
};

export function registerBadgeSet(name, statuses) {
  sets[name] = { ...(sets[name] || {}), ...statuses };
}

export function resolveBadge(set, status) {
  const entry = (sets[set] || {})[status] || sets.default[status];
  return entry ? { text: entry[0], tone: entry[1] } : null;
}
